import { Injectable, Injector } from '@angular/core';

import { ApiInterface, ApiService } from '../../api/api.service';

import { FollowModel } from '../models/follow.model';

@Injectable()
export class FollowService extends ApiService implements ApiInterface {
    public restEndpoint = '{entity}/{entityId}';
    public model        = FollowModel;
    public entityName   = 'follow';
    public collection;

    constructor(injector: Injector) {
        super(injector);
    }

    public follow() {
        return this.request('get', this.getEndpointUrl() + '/follow', false);
    }

    public unfollow() {
        return this.request('get', this.getEndpointUrl() + '/unfollow', false);
    }

    public checkFollowing() {
        return this.request('get', this.getEndpointUrl() + '/check-following', false);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/follows/services/follow.service.ts